export default __webpack_public_path__ + "info-drag-and-drop@2x.png";